import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommandesService } from 'src/app/services/commandes/commandes.service';

@Component({
  selector: 'app-details-trailer',
  templateUrl: './details-trailer.component.html',
  styleUrls: ['./details-trailer.component.css'],
})
export class DetailsTrailerComponent implements OnInit {
  isLoading: Boolean = true;

  trailerId: string;
  trailer: any = {};

  offers: any;

  constructor(
    private route: ActivatedRoute,
    private cmdsService: CommandesService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.trailerId = params.trailerId;
      // this._fetchTrailer();
      this.generateTrailer();
    });
  }

  // _fetchTrailer() {
  //   this.cmdsService.getOneTrailer(this.trailerId).then((data: any) => {
  //     console.log('getOneTrailer :: ');
  //     console.log(data);
  //     if (data) {
  //       this.isLoading = false;
  //       this.trailer = data;
  //     } else {
  //       alert('Aucune remorque valide');
  //       location.href = '/all-trailers';
  //     }
  //   });
  // }

  generateTrailer() {
    this.cmdsService.generateTrailer(this.trailerId).then((result: any) => {
      // console.log('generateTrailer :: ');
      // console.log(result);
      if (result.response && result.data) {
        this.isLoading = false;
        this.trailer = result.data;
      } else {
        alert(result.msg || 'Aucune remorque valide');
        location.href = '/all-trailers';
      }
    });
  }
}
